import { Injectable } from '@angular/core';
import { RestAPIService } from '../rest-api.service';
@Injectable({
  providedIn: 'root'
})
export class PassportdetailsUrlService {
  private readonly passportBaseApi = '/api/passport-details';
  private readonly user = '/user';
  private readonly userId_param = 'userId'
  constructor(private restApi:RestAPIService) { }
  getBaseUrl(){
    return this.passportBaseApi;
  }
  getUserUrl(userId) {
    return this.passportBaseApi + this.user
      + '?' + this.userId_param + '=' + userId
  }
  getByFieldUrl(field){
    return this.passportBaseApi+ this.getByField(field)
  }
  private getByField(field){
    return '/'+field;
  }
}
